define("braintree.Main.ModelSS2",["Backbone","Utils"],function(e,t){return e.Model.extend({urlRoot:t.getAbsoluteUrl(getExtensionAssetsPath("Modules/Main/SuiteScript2/Braintree.Details.ss"),!0)})});
